import { withInstall } from '@bigin/utils'

import PhoneInput from './src/phone-input.vue'

export const BPhoneInput = withInstall(PhoneInput)
export default BPhoneInput

export * from './src/phone-input'
